import { useEffect, useState } from "react";
import { authApi } from "../../lib/authApi";
import { KpiGrid, pct, hrs, num, inr } from "./AnalyticsShared";

export const CustomerMetrics = () => {
  const [data, setData] = useState(null);
  useEffect(() => { authApi.get("/customer/analytics").then((r) => setData(r.data)).catch(() => setData({ error: true })); }, []);
  if (!data || data.error || data.empty) return null;
  return (
    <section className="mb-8" data-testid="customer-metrics">
      <h2 className="text-base md:text-lg font-semibold font-heading mb-3">Your activity</h2>
      <KpiGrid items={[
        { label: "RFQs quoted", value: `${num(data.rfq.quoted)} / ${num(data.rfq.total)}`, hint: `${num(data.rfq.approved)} approved · ${inr(data.rfq.approved_value)}`, testId: "customer-kpi-rfqs" },
        { label: "Quote turnaround", value: hrs(data.rfq.submit_to_quote), hint: `median · n=${data.rfq.submit_to_quote.sample}`, testId: "customer-kpi-quote-time" },
        { label: "Orders delivered", value: `${num(data.orders.delivery_confirmed)} / ${num(data.orders.total)}`, hint: `${num(data.orders.active)} in progress`, testId: "customer-kpi-orders" },
        { label: "On-time delivery", value: pct(data.delivery.on_time_rate), hint: `${data.delivery.on_time}/${data.delivery.delivered} vs quoted lead time`, testId: "customer-kpi-ontime" },
      ]} />
    </section>
  );
};
